import { createStore, createEffect, createEvent, combine } from 'effector';
import { RegistrationApi, type SignupRequest, type SignupResponse } from '@shared/api';
import { ApiUtils } from '@shared/utils';

const signupEffect = createEffect((request: SignupRequest) => RegistrationApi.signup(request));
const clearEvent = createEvent();

const $dataStore = createStore<SignupResponse | null>(null)
  .on(signupEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(signupEffect.pending, (_, data) => data)
  .on(signupEffect.fail, () => false)
  .on(signupEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(signupEffect, () => null)
  .on(signupEffect.fail, (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while Registering. Please try again.').message)
  .on(signupEffect.done, () => null)
  .reset(clearEvent);

export const $signupStore = {
  events: {
    signup: signupEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
